import { render, staticRenderFns } from "./briefing.vue?vue&type=template&id=47382940&scoped=true&"
import script from "./briefing.vue?vue&type=script&lang=js&"
export * from "./briefing.vue?vue&type=script&lang=js&"
import style0 from "./briefing.vue?vue&type=style&index=0&id=47382940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47382940",
  null
  
)

export default component.exports